// import glider from 'glider-js';
// Commented out because import is not made so it would actually work
// import testimonialCarousel from './site/glider/testimonial-carousel';

// export { glider };

import initUiComponents from "./inc/init";

// Initializes all UI components and starts AlpineJS
initUiComponents();

const initializeShippingCartButtons = () => {
	const cartButtons = Array.from(
		document.querySelectorAll("[data-shipping-cart-button]"),
	);

	if (!cartButtons.length) {
		return;
	}

	const cartButtonApi = cartButtons[0].dataset.cartButtonApi;

	if (!cartButtonApi) {
		return;
	}

	requestAnimationFrame(async () => {
		try {
			const response = await fetch(cartButtonApi, {
				headers: {
					Accept: "application/json",
				},
			});

			if (!response.ok) {
				return;
			}

			const data = await response.json();
			const count = Number(data.count ?? 0);
			const isVisible = Boolean(data.visible) && count > 0;

			for (const cartButton of cartButtons) {
				if (!isVisible) {
					cartButton.remove();
					continue;
				}

				const countNode = cartButton.querySelector("[data-cart-button-count]");

				if (countNode) {
					countNode.textContent = `(${count})`;
				}

				cartButton.hidden = false;
				cartButton.classList.remove("hidden");
				cartButton.setAttribute("aria-hidden", "false");
			}
		} catch {
			// Keep the cached shell hidden when cart state cannot be loaded.
		}
	});
};

// Minna has marked every link in this Galaxy as "Open in new tab" so we
// have to remove it for internal links because she's also too lazy to go
// back and fix her mistakes in the content itself ¯\_(ツ)_/¯
document.addEventListener("DOMContentLoaded", () => {
	initializeShippingCartButtons();

	// Get the current domain
	const currentDomain = window.location.origin;

	// Function to process a single link
	function processLink(link) {
		const href = link.getAttribute("href");

		// Skip if no href
		if (!href) {
			return;
		}

		// Always open PDF files in a new tab
		if (href.toLowerCase().endsWith(".pdf")) {
			link.setAttribute("target", "_blank");
			link.setAttribute("rel", "noopener noreferrer");
			return;
		}

		// Check if it's an internal link
		const isInternal =
			href.startsWith("/") ||
			href.startsWith(currentDomain) ||
			!href.includes("://") ||
			href.includes("api.shipit.ax");

		if (isInternal) {
			// Remove target="_blank" from internal links
			link.removeAttribute("target");

			// Also remove rel="noopener" if it was added automatically
			if (link.getAttribute("rel") === "noopener") {
				link.removeAttribute("rel");
			}
		}
	}

	// Process all existing links
	for (const link of document.querySelectorAll("a")) {
		processLink(link);
	}

	// Set up a MutationObserver to handle dynamically added links
	const observer = new MutationObserver((mutations) => {
		for (const mutation of mutations) {
			for (const node of mutation.addedNodes) {
				if (node.nodeType === 1) {
					// ELEMENT_NODE
					if (node.tagName === "A") {
						processLink(node);
					}

					for (const link of node.querySelectorAll("a")) {
						processLink(link);
					}
				}
			}
		}
	});

	observer.observe(document.body, {
		childList: true,
		subtree: true,
	});

	// Stamp data-label attributes on every <td> in .bard tables so the CSS
	// ::before pseudo-element can display the column heading above each cell
	// on mobile (see bard.css .bard table td::before).
	for (const table of document.querySelectorAll(".bard table")) {
		// Prefer proper <th> elements, but Statamic's Bard/TipTap outputs the
		// header row as plain <td> cells with no <th> at all, so fall back to
		// reading the first row's cells as column headers.
		let headers = Array.from(table.querySelectorAll("th"));

		if (!headers.length) {
			const firstRow = table.querySelector("tr");
			if (firstRow) {
				headers = Array.from(firstRow.querySelectorAll("td"));
			}
		}

		// Skip the first row — it's the header row (hidden on mobile via CSS).
		const dataRows = table.querySelectorAll("tbody tr:not(:first-child)");
		for (const row of dataRows) {
			for (const [index, cell] of row.querySelectorAll("td").entries()) {
				if (headers[index]) {
					cell.setAttribute("data-label", headers[index].textContent.trim());
				}
			}
		}
	}
});
